// success/warning/info use text-{color}-700 (not -600) on the -100 tint — axe (task 11.6) found
// -600-on-100 at ~4.0-4.1:1 contrast, below the 4.5:1 AA minimum; -700 clears it comfortably.
// Dark mode uses `bg-{color}-500/15` (not `-300/20`): tinting the badge with the same light hue
// as its `-300` text left background and text too close in lightness (axe measured ~2.3:1); the
// darker/more-saturated 500 tone at low opacity keeps enough separation from the light text.
/** Paleta apagada fija (8 tonos derivados de gold/stone/semánticos, ui-design-system.md §3). */
export const MUTED_PALETTE = [
  'bg-gold-100 text-gold-700 dark:bg-gold-500/15 dark:text-gold-300',
  'bg-success-100 text-success-700 dark:bg-success-500/15 dark:text-success-300',
  'bg-warning-100 text-warning-700 dark:bg-warning-500/15 dark:text-warning-300',
  'bg-danger-100 text-danger-600 dark:bg-danger-500/15 dark:text-danger-300',
  'bg-info-100 text-info-700 dark:bg-info-500/15 dark:text-info-300',
  'bg-sunken text-secondary',
  'bg-selected text-brand',
  'bg-surface-raised text-secondary border border-default',
];

export function hashString(value: string): number {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function colorForString(value: string): string {
  return MUTED_PALETTE[hashString(value) % MUTED_PALETTE.length];
}
